import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import Error from './Error';

const useStyles = makeStyles({
  tableContainer: {
    width: '50%',
    padding: '20px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '20px'
  },
  table: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '20px'
  },
  tableHeader: {
    width: '50%'
  },
  monthlyTable: {
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  monthlyTableHeader: {
    backgroundColor: ''
  },
  heading: {
    borderBottom: 'solid #faab4b',
    marginBottom: '10px'
  }
});

function MonthlyRaw(props) {
  return (
    <TableRow>
      <TableCell>{props.monthly_data.year_month}</TableCell>
      <TableCell>{props.monthly_data.number}</TableCell>
    </TableRow>
  );
}

function MonthlyTable(props) {
  const classes = useStyles();
  const tables = [];
  props.sent_data.monthly_total_message.forEach((monthly_data) => {
    tables.push(<MonthlyRaw monthly_data={monthly_data} key={monthly_data.year_month} />);
  });

  return (
    <>
      <Typography className={classes.heading} variant="h5">
        月別送信履歴
      </Typography>
      <Table className={classes.monthlyTable}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>日付(年-月)</TableCell>
            <TableCell align="left">送信件数</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{tables}</TableBody>
      </Table>
    </>
  );
}

function SendDataTable(props) {
  const classes = useStyles();
  const sent_data = props.sent_data;

  return (
    <>
      <Typography className={classes.heading} variant="h5">
        当月送信状況
      </Typography>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell component="th" className={classes.tableHeader}>
              チャネルID
            </TableCell>
            <TableCell align="left">{sent_data.channel_id}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" className={classes.tableHeader}>
              送信可能総数
            </TableCell>
            <TableCell align="left">{sent_data.transmittable_number}件</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" className={classes.tableHeader}>
              当月送信件数
            </TableCell>
            <TableCell align="left">{sent_data.sent_number_this_month}件</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" className={classes.tableHeader}>
              当月送信残数
            </TableCell>
            <TableCell align="left">{sent_data.remaining_number_this_month}件</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
}

function ContentsTable(props) {
  const classes = useStyles();
  const sent_data = props.sent_data;
  const monthly_tables = [];

  monthly_tables.push(sent_data.monthly_total_message.length ? <MonthlyTable sent_data={sent_data} key={sent_data.channel_id} /> : '');

  return (
    <TableContainer className={classes.tableContainer} component={Paper}>
      <SendDataTable sent_data={sent_data} key={sent_data.channel_id} />
      {monthly_tables}
    </TableContainer>
  );
}

function Contents(props) {
  const [error, setIsError] = React.useState(false);
  const [sentData, setSentData] = React.useState({
    items: []
  });

  React.useEffect(() => {
    async function fetchData() {
      setIsError(false);
      const apiUrl = process.env.REACT_APP_GET_TRANS_NUMBER_DATA_URL;
      try {
        await axios
          .get(apiUrl, {
            headers: {
              Authorization: `${props.token}`
            }
          })
          .then((res) => {
            setSentData(res.data);
          });
      } catch (error) {
        setIsError(true);
      }
    }
    fetchData();
    // トークンの変更タイミングは初回マウント時のみなので、トークンへの依存を除外する
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tables = [];
  sentData.items.forEach((sent_data) => {
    tables.push(<ContentsTable sent_data={sent_data} key={sent_data.channel_id} />);
  });

  return error ? <Error /> : <>{tables}</>;
}

export default Contents;
